export default {
  visuais: [],
  visual: {}
}